export default __webpack_public_path__ + "static/media/fahrenheit-degrees-1.a427ff32.svg";